import { BaseSearchModel } from "../../../openApiClients/generated/EngineeringUK.Sites";

export async function getTemplateHtml(element: BaseSearchModel) {
  try {
    const module = await import(`../resultsTemplates/${element.contentType}.ts`);
    return module.render(element);
  }
  catch (e) {
    const module = await import("../resultsTemplates/defaultTemplate");
    return module.render(element);
  }
}
